/*
 * @Description: Description
 * @Autor: Chen
 * @Date: 2020-05-20 14:17:08
 * @LastEditors: snzo.chen
 * @LastEditTime: 2021-12-27 14:37:28
 */
import { Injectable } from '@angular/core';
import { ServicesModule } from '../services/services.module';
import { Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators';
import { HttpClient } from '@angular/common/http';
import { AnyJson } from '../services/data-types/common.types';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
declare var aesUtil: any;

@Injectable({
  providedIn: ServicesModule
})
export class AuthService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private storageServe: StorageService
  ) { }
  isLoggedIn = false;
  // store the URL so we can redirect after logging in
  redirectUrl: string;
  operator: string;
  token!: string;

  newDoLogin(params: AnyJson): Observable<AnyJson> {
    const encryptKey = '1kQdPy54X23VjXT7f9nl6d4f2m8238ET';
    const aesRandomKey = aesUtil.getKey();
    const aesKey = aesUtil.encrypt(aesRandomKey, encryptKey);
    const data = aesUtil.encrypt(params, aesRandomKey);
    const body = new URLSearchParams();
    body.set('aesKey', aesKey);
    body.set('data', data);
    body.set('timestamp', (new Date().getTime()).toString());
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' };
    return this.http.post('/user/doLogin', body, { headers })
      .pipe(map((res) => res as AnyJson));
  }
  doLogin(params: AnyJson): Observable<AnyJson> {
    return this.http.get('/user/doLogin', { params })
      .pipe(map((res) => res as AnyJson));
  }
  logout(): void {
    this.storageServe.removeStorage('isLoggedIn');
    this.storageServe.removeStorage('token');
    this.isLoggedIn = false;
    this.operator = null;
    this.router.navigate(['/home']);
  }
}
